import { useTranslation } from "react-i18next";

export const OrSeparator = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center gap-6">
      <hr className="flex-1 border-border-tertiary" />
      <span className="text-body-xs font-semibold leading-none text-foreground-secondary">
        {t("portal:common.or")}
      </span>
      <hr className="flex-1 border-border-tertiary" />
    </div>
  );
};
